import * as Scrivito from "scrivito";

const TextFooterWidget = Scrivito.provideWidgetClass("TextFooterWidget", {
  onlyInside: "FooterContainerWidget",
  attributes: {
    title: "string",
    text: "html",
  },
  extractTextAttributes: ["title", "text"],
});

export default TextFooterWidget;
